import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, Card, CardImg} from 'reactstrap';

class RobotModal extends Component {
    state = {
        modal: true
    }

    toggle = () => {
        this.setState({
          modal: !this.state.modal
        });
        this.props.toggleModal();
    }

    componentDidMount(){
    }

    render() {
        let { details, imgUrl, robotName } = this.props;
        return (
            <div>
                <Modal isOpen={this.state.modal} toggle={this.toggle} >
                    <ModalHeader toggle={this.toggle}>{robotName}</ModalHeader>
                    <ModalBody>
                        <Card>
                            <CardImg top width="100%" src={imgUrl} />
                        </Card>
                        {details}
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default RobotModal;


// WEBPACK FOOTER //
// ./src/components/widgets/modals/robotmodal.js